module.exports = __webpack_public_path__ + "static/img/973_phase_function_Paper_Points.d0297bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/973_phase_function_Paper_Points.png
// module id = gOGT
// module chunks = 0